import React from 'react';

class MicroFrontend extends React.Component {
  componentDidMount() {
    const { name, host } = this.props;
    const scriptId = `micro-frontend-script-${name}`;

    if (document.getElementById(scriptId)) {
      this.renderMicroFrontend();
      return;
    }

    fetch(`${host}/asset-manifest.json`, { mode: 'cors' })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Failed to fetch manifest for ${name}: ${res.statusText}`);
        }
        return res.json();
      })
      .then(manifest => {
        const promises = [];
        
        // Load CSS files
        Object.keys(manifest.files)
          .filter(key => key.endsWith('.css'))
          .forEach(key => {
            const link = document.createElement('link');
            link.id = scriptId;
            link.href = `${host}${manifest.files[key]}`;
            link.rel = "stylesheet";
            document.head.appendChild(link);
            promises.push(new Promise(resolve => {
              link.onload = resolve;
            }));
          });

        // Load JS files
        Object.keys(manifest.files)
          .filter(key => key.endsWith('.js'))
          .forEach(key => {
            const script = document.createElement('script');
            script.id = scriptId;
            script.crossOrigin = '';
            script.src = `${host}${manifest.files[key]}`;
            document.head.appendChild(script);
            promises.push(new Promise(resolve => {
              script.onload = resolve;
            }));
          });

        Promise.all(promises).then(this.renderMicroFrontend);
      })
      .catch(err => {
        console.error(`Error loading ${name}:`, err);
      });
  }

  componentWillUnmount() {
    const { name } = this.props;
    window[`unmount${name}`] && window[`unmount${name}`](`${name}-container`);
  }

  renderMicroFrontend = () => {
    const { name, history } = this.props;
    window[`render${name}`] && window[`render${name}`](`${name}-container`, history);
  };

  render() {
    return <main id={`${this.props.name}-container`} />;
  }
}

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;